import RepeaterImg from "../../../../data/icons/repeater.png";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinus, faPlus} from "@fortawesome/free-solid-svg-icons";
import React, {useEffect, useRef} from "react";
import styled from "styled-components";


const MarkerImage = ({
                         propImageUrl = '',
                         propMarkerList = [],
                     }) => {
    const frame = useRef();

    useEffect(() => {

    }, [propMarkerList])
    return (
        <div className={"narrow-floor-plan-container-contents text-center"}>
          <div className={"narrow-floor-plan-image-container"}>
            <div className={"frame"} style={{height: 650}} >
              {/*<TransformWrapper>*/}
              {/*  <TransformComponent>*/}
                  <MarkerContainer ref={frame}
                                   img_url = {propImageUrl}
                                   className={'marker-container'}
                  >
                    {propMarkerList.map((data, index) => (
                        <Marker
                            key={data.id}
                            top={data.top}
                            left={data.left}
                            // onDragStart={dragStartHandler}
                            // onDrag={dragHandler}
                            // onDragEnd={e => dragEndHandler(e, index)}
                            // onClick={e => clickHandler(e, index)}
                            // border={copy === index}
                            draggable
                            className={"stock"}
                        >
                          <Details
                              // onClick={(e) => e.stopPropagation()}
                              // onDragStart={(e) => e.stopPropagation()}
                              // draggable={(e) => e.stopPropagation()}
                          >
                            <img
                                src={data.img}
                                // alt={data.details.alt}
                                className={"marker icon align-middle"}
                                onClick={(event) => {
                                  event.stopPropagation();
                                }}
                                onDragStart={(e) => e.stopPropagation()}
                                onDrag={e => e.stopPropagation()}
                                onDragEnd={e => e.stopPropagation()}
                                draggable={false}
                            />
                            {/*<Close*/}
                            {/*    className={"btn p-0"}*/}
                            {/*    onClick={(event) => {*/}
                            {/*      // event.stopPropagation();*/}
                            {/*      setTargets((propMarker) => {*/}
                            {/*        const newMarkerList = propMarkerList.filter(target => target.id !== data.id);*/}
                            {/*        return newMarkerList;*/}
                            {/*      })*/}
                            {/*    }}*/}
                            {/*    // onDragStart={(e) => e.stopPropagation()}*/}
                            {/*    // draggable={(e) => e.stopPropagation()}*/}
                            {/*>*/}
                            {/*  ✖*/}
                            {/*</Close>*/}
                          </Details>
                        </Marker>))}


                  </MarkerContainer>
                  {/*<img src={img} className='stock-container mw-100 mh-100'/>*/}
              {/*  </TransformComponent>*/}
              {/*</TransformWrapper>*/}
            </div>
          </div>
          <div className={'zoom m-3'}>
            <ul>
              <li>
                <Button className={'zoom-in'}>
                  <FontAwesomeIcon icon={faPlus}
                                   className={'d-inline'}/>
                </Button>
              </li>
              <li>
                <Button className={'zoom-out mt-2'}>
                  <FontAwesomeIcon icon={faMinus}
                                   className={'d-inline'}/>
                </Button>
              </li>
            </ul>
          </div>
        </div>
    );
}

export default MarkerImage;

const MarkerContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform-origin: left center;
  background-image: ${props => `${props.img_url}`};
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center;
`;

const Marker = styled.div`
  position: absolute;
  top: ${props => `${props.top}px`};
  left: ${props => `${props.left}px`};
  width: auto;
  height: auto;
  //padding-top: 22px;
    //border: ${props => props.border && '1px solid gray'}; 
  //border-radius: 10px;
  //background-color: black;
  //overflow: hidden;
  //box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  text-align: center;
  cursor: pointer;
`;

const Details = styled.div`
  position: relative;
  z-index: 100;
  width: 100%;
  //background-color: #d3dae3;
  //margin-top: 20px;
`;

const Close = styled.button`
  position: absolute;
  top: -20px;
  right: -20px;
  //cursor: pointer;
  &:hover {
    background-color: var(--color-gray) !important;
  }
`;